module.exports = __webpack_public_path__ + "static/a11ytab-59f9259a97ae724d26db8167f4d9f935.png";